var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M3.75 8.75h2.5v2.5h-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M8.75 8.75h2.5v2.5h-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M13.75 8.75h2.5v2.5h-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M3.75 13.75h2.5v2.5h-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M8.75 13.75h2.5v2.5h-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "M13.75 13.75h2.5v2.5h-2.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 16.5,
    x: 0.5,
    y: 3,
    stroke: "#80959D",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    strokeWidth: 2,
    d: "M5.002.042v6.23M15.002.042v6.23"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    d: "M4.25 9.25h1.5v1.5h-1.5z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    d: "M9.25 9.25h1.5v1.5h-1.5z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    d: "M14.25 9.25h1.5v1.5h-1.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    d: "M4.25 14.25h1.5v1.5h-1.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    d: "M9.25 14.25h1.5v1.5h-1.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    d: "M14.25 14.25h1.5v1.5h-1.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/calender-icon.fdecd97842fc465f4bfdbc8cd5d77705.svg";
export { ForwardRef as ReactComponent };